/** Authored execute bonuses. Evaluate from the defender at each accepted hit,
 * before mitigation/rounding; never from a client-provided multiplier. */
const EXECUTE_ABILITIES = new Set(['execute', 'death_coil', 'drain_soul']);

export function conditionalAbilityDamageMultiplier(
  abilityId: string | undefined,
  defender: { health?: number; maxHealth?: number },
): number {
  const { health, maxHealth } = defender;
  return abilityId !== undefined && EXECUTE_ABILITIES.has(abilityId)
    && Number.isFinite(health) && Number.isFinite(maxHealth)
    && health! > 0 && maxHealth! > 0 && health! < maxHealth! * 0.5
    ? 1.5 : 1;
}
